import React, { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";

import ToastNotification from "./ToastNotification"; // Import the ToastNotification component
import {addNotification} from "./ReactNotification";

export const TodoForm = (props) => {
    const [name, setName] = useState('');
    const [showToast, setShowToast] = useState(false); // State for controlling toast visibility
    const [toastMessage, setToastMessage] = useState(""); // State for toast message
    const [toastTitle, setToastTitle] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setToastTitle("Error");
            setToastMessage("Please enter a task name."); // Set the toast message
            setShowToast(true); // Show toast if name is empty
            return;
        }

        props.addTask(name);
        addNotification('Item Added - ' + name, 'Todo Item has been added!');
        setName('');
        setToastTitle("Information");
        setToastMessage("Task added successfully."); // Set the toast message
        setShowToast(true); // Show toast

    }

    const handleChange = (e) => {
        setName(e.target.value);
    }

    return (
        <Form className="todo-form" onSubmit={handleSubmit}>
            <Form.Group>
                <InputGroup className="mb-7">
                    <Form.Control
                        type="text"
                        id="new-todo-input"
                        name="text"
                        autoComplete="off"
                        value={name}
                        onChange={handleChange}
                        placeholder="Enter a task"
                    />
                    <Button variant="primary" type="submit">Add</Button>
                </InputGroup>
            </Form.Group>
            <ToastNotification
                show={showToast}
                onClose={() => setShowToast(false)}
                message={toastMessage} // Pass the message to the ToastNotification component
                toastTitle={toastTitle}
               // headerStyle={{ backgroundColor: {toastTitle = 'Error' : '#ffcccc','green'}} // Set the header style
            />
        </Form>

    );
}
